import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router/index.js'
import authService from '../services/authService.js'

Vue.use(Vuex)
Vue.prototype.$nombreAplicacion=""

Vue.prototype.$rules= {
  requerido: (value) => !!value || "Debe llenar este campo.",
  requeridoArchivo: (value) => !!value || "Debe seleccionar un archivo.",
  requerido2: (value) => !!value[0] || "Debe llenar este campo.",
  requerido3: (value) => !!value.id || "Debe llenar este campo.",
  numero: (value) => {
    const pattern = /\d{1,3}(?:,\d{3})*(?:\.\d+)?/;
    return pattern.test(value) || "Ingrese un número válido.";
  },
  fecha: (value) => {
    const pattern = /^\d{4}([\-/.])(0?[1-9]|1[1-2])\1(3[01]|[12][0-9]|0?[1-9])$/;
    return pattern.test(value) || "Ingrese una fecha válida.";
  },
  soloLetras: (value) => {
    const pattern = /^[a-zA-Z\s]*$/;
    return pattern.test(value) || "Ingrese un Nombre Válido.";
  },
  
  mayorCero: (value) => value > 0.01 || "Ingrese una monto superior.",
  balanceCero: (value) => value < 0.001 && value > -0.001 || "El monto del balance debe ser igual a 0.",
  balanceMayorCero: (value) => parseFloat((value.replace(/\./g, "")).replace(/\,/g, ".")) >0|| "El monto del balance debe ser mayor a 0.",
  
   
  
  GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
  GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
  maximoAjuste: (value) => value <= 1 || "El ajuste no debe ser mayor a 1",
  celular: (value) =>
    value.length === 8 || "El número debe tener 8 caracteres.",
  min2: (value) =>
    value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
  min5: (value) =>
    value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
  max10: (value) =>
    value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
  max25: (value) =>
    value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
  max30: (value) =>
    value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
  max45: (value) =>
    value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
  max50: (value) =>
    value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
  max100: (value) =>
    value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
  email: (value) => {
    const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
    return pattern.test(value) || "Ingrese un email válido.";
  },
}

export default new Vuex.Store({

  
  state: {
    snackbars:[],
    token: null,
    usuario: null,
    titulo: null
  },
  mutations: {
    SET_SNACKBAR(state,snackbar){
      state.snackbars=state.snackbars.concat(snackbar);      
    },
     setToken(state,token){
      state.token=token
    },
    setUsuario (state,usuario){
      state.usuario=usuario
    },
    setTitulo(state,titulo){
      state.titulo=titulo
    }
  },
  actions: {
    setSnackbar({commit},snackbar){
      snackbar.color=snackbar.color || 'success'
      snackbar.timeout=4000;
      snackbar.showing=true;
      commit('SET_SNACKBAR',snackbar);
    },

    guardarToken({commit},token){
      commit("setToken", token)
      commit("setUsuario", decode(token))
      localStorage.setItem("token", token)
    },
    autoLogin({commit}){
      let token = localStorage.getItem("token")
      if (token){
        try {
          // Verificar si el token no ha expirado
          const decodedToken = decode(token);
          const currentTime = Date.now() / 1000;
          
          if (decodedToken.exp > currentTime) {
            commit("setToken", token)        
            commit("setUsuario", decodedToken)
            // Solo redirigir si estamos en login y el token es válido
            if (router.currentRoute.name === 'Login') {
              router.push({name: 'Home'});
            }
          } else {
            // Token expirado, limpiar
            localStorage.removeItem("token");
            if (router.currentRoute.name !== 'Login') {
              router.push({name: 'Login'});
            }
          }
        } catch (error) {
          // Token inválido, limpiar
          localStorage.removeItem("token");
          if (router.currentRoute.name !== 'Login') {
            router.push({name: 'Login'});
          }
        }
      } else if (router.currentRoute.name !== 'Login') {
        // No hay token, redirigir a login solo si no estamos ya ahí
        router.push({name: 'Login'});
      }
    },
    async salir({commit}){
      // Limpiar el estado local primero
      commit("setToken", null)
      commit("setUsuario", null)
      localStorage.removeItem("token")
      
      // También limpiar sessionStorage por si acaso
      sessionStorage.clear()
      
      // Usar el servicio de autenticación para el logout
      await authService.performLogout()
    },
    actualizarTitulo({commit},title){
      commit("setTitulo", title)
    }
  },
  modules: {
  }
})
